<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 9,
      height: 8,
      color: 'currentColor',
      viewBoxValue: `0 0 9 8`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <path
      d="M3.97393 8V0H5.83076V8H3.97393ZM0.902344 4.88889V3.11111H8.90234V4.88889H0.902344Z"
      fill="currentColor"
    />
  </IconBase>
</template>

<style scoped lang="scss"></style>
